<template>
  <div
    v-if="annualAmount"
    class="flex flex-1 flex-row bg-bubblegum-50 items-center space-x-2 px-standard py-2 border-t border-neutral-200"
  >
    <fa
      :icon="getIcon"
      class="text-base text-bubblegum"
    />
    <i18n
      :path="bannerText"
      tag="span"
      class="text-xs text-neutral-900"
    >
      <template #planName>
        <span class="text-bubblegum-700 font-semibold">{{ planName }}</span>
      </template>
      <template
        v-if="hasPromotion"
        #originalPrice
      >
        <div class="inline-block line-through">
          {{ formattedOriginalMonthlyAmount }}
        </div>
      </template>
      <template #price>
        <div class="inline-block">
          {{ formattedMonthlyAmount }}
        </div>
      </template>
      <template #frequency>
        <div class="inline-block">
          /{{ $t('membership-subscriptions.monthly-abbreviation') }}
        </div>
      </template>
    </i18n>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faGift } from '@fortawesome/pro-light-svg-icons';
import { getCurrentInstance } from 'vue';

import useCheckoutHelpers from '@/composables/use-checkout-helpers';
import useMembershipPromotion from '@/composables/use-membership-promotion';
import HasYearlySubscriptionPlan from '@/mixins/HasYearlySubscriptionPlan';

library.add({ faGift });

export default {
  name: 'VetsterSearchTileBanner',

  mixins: [HasYearlySubscriptionPlan],

  setup() {
    const root = getCurrentInstance().proxy.$root;
    const { isSubscription } = useCheckoutHelpers(root);
    const { isPromotionEnabled } = useMembershipPromotion(root);

    return {
      isPromotionEnabled,
      isSubscription,
    };
  },

  computed: {
    getIcon() {
      return this.isPromotionEnabled ? ['fal', 'gift'] : ['fal', 'tag'];
    },
    bannerText() {
      if (this.isSubscription) {
        return 'search.book-with';
      }

      return 'search.subscribe-save-with-plan';
    },
  },
};
</script>
